import { defineMessages } from 'react-intl';

export default defineMessages({
  dismissLabel: {
    id: 'sku.error-banner.dismiss-label',
    defaultMessage: 'Dismiss',
  },
});
